import { UntypedFormControl } from '@angular/forms';

/**
 * Validates that the current FormControl value is equal to the FormControl name passed in.
 * @param confirmPasswordInput Name of FormControl to check value
 * @returns
 */
export function PasswordConfirmValidator(confirmPasswordInput: string) {
  let passwordFormControl: UntypedFormControl;
  let passwordConfirmControl: UntypedFormControl;

  return (control: UntypedFormControl) => {
    if (!control.parent) {
      return null;
    }

    if (!passwordConfirmControl) {
      passwordConfirmControl = control;
      passwordFormControl = control.parent.get(confirmPasswordInput) as UntypedFormControl;
      passwordFormControl.valueChanges.subscribe(() => {
        passwordConfirmControl.updateValueAndValidity();
      });
    }
    // empty string, null and undefined are considered as equal
    if (!passwordFormControl.value && !passwordConfirmControl.value) {
      return null;
    }
    if (passwordFormControl.value != passwordConfirmControl.value) {
      return { notMatch: true };
    }

    return null;
  };
}
